import { render, staticRenderFns } from "./Datastreams.vue?vue&type=template&id=5c8bdc26&scoped=true"
import script from "./Datastreams.vue?vue&type=script&lang=ts"
export * from "./Datastreams.vue?vue&type=script&lang=ts"
import style0 from "./Datastreams.vue?vue&type=style&index=0&id=5c8bdc26&prod&scoped=true&lang=scss"
import style1 from "./Datastreams.vue?vue&type=style&index=1&id=5c8bdc26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bdc26",
  null
  
)

export default component.exports